import { Button, type ButtonProps } from '@chakra-ui/react'
import { useRouter } from 'next/router'

import AuthLink from '@/components/Auth/AuthLink'

export default function SignupButton({
  text = 'Sign Up',
  ...props
}: {
  text?: string
} & ButtonProps): JSX.Element | null {
  const router = useRouter()

  return (
    <AuthLink mode="signup" returnTo={router.asPath}>
      <Button {...props}>{text}</Button>
    </AuthLink>
  )
}
